import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { USER_ROLES_BY_NAME } from 'src/constants/userSetting';

/**
 * Whether the signed-in account is Livable staff, read from the access token.
 *
 * Not `store.account.userProfile.isUserLivableStaff`: that view reads the localStorage mirror,
 * which on a cold load is written after the first render and is not observable, so a gate keyed on
 * it settles on "not staff" and never re-runs. The token carries the role on the first render.
 * custom:role, not custom:permissions - the latter is a JSON policy array in this pool.
 */
export const isLivableStaffFromToken = () => {
  var _parseJwt$customRole, _parseJwt;
  const role = (_parseJwt$customRole = (_parseJwt = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken))) === null || _parseJwt === void 0 ? void 0 : _parseJwt['custom:role']) !== null && _parseJwt$customRole !== void 0 ? _parseJwt$customRole : '';
  return USER_ROLES_BY_NAME[role] === USER_ROLES_BY_NAME.LivableSuperAdmin || USER_ROLES_BY_NAME[role] === USER_ROLES_BY_NAME.LivableAdmin;
};